import React, { useState, useEffect } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap';
import { toast } from 'react-toastify';
import { FaPencilAlt } from 'react-icons/fa';
import { apiURL } from '../../config';
import Footer from 'components/Footers/Footer';

const GeneralSettings = () => {
    const token = localStorage.getItem("token");

    const [settings, setSettings] = useState(null);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editedSettings, setEditedSettings] = useState({
        schoolName: '',
        schoolAddress: '',
        schoolPhoneNumber: '',
        schoolEmail: '',
        schoolLogo: '',
    });
    const baseURL = apiURL;

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const response = await fetch(`${baseURL}/superadmin/school-settings`, {
                method: 'GET', // or any other HTTP method like POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': `Bearer ${token}`, // Add token to headers
                    // You can add other headers here if needed
                },
            });
            const data = await response.json();
            if (data && data.length > 0) {
                setSettings(data[0]);
                setEditedSettings(data[0]);
            }
        } catch (error) {
            console.error('Error fetching settings:', error);
            toast.error('Error fetching settings!');
        }
    };

    const handleEditClick = () => {
        setEditModalOpen(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditedSettings(prevSettings => ({
            ...prevSettings,
            [name]: value,
        }));
    };


    const handleUpdateSettings = async (e) => {
        e.preventDefault();
        try {
            if (settings) {
                const response = await fetch(`${baseURL}/superadmin/school-settings/${settings._id}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify(editedSettings),
                });
                if (response.ok) {
                    toast.success('Settings updated successfully!');
                    fetchSettings();
                    setEditModalOpen(false);
                } else {
                    toast.error('Error updating settings!');
                }
            }
            else {
                const response = await fetch(`${baseURL}/superadmin/school-settings`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify(editedSettings),
                });
                if (response.ok) {
                    toast.success('Settings updated successfully!');
                    fetchSettings();
                    setEditModalOpen(false);
                } else {
                    toast.error('Error updating settings!');
                }
            }

        } catch (error) {
            console.error('Error updating settings:', error);
            toast.error('Error updating settings!');
        }
    };


    return (
        <>
            <div
                className="header   d-flex align-items-center"
                style={{
                    minHeight: "600px",
                    backgroundImage:
                        "url(" + require("../../assets/img/theme/alRehman.jpg") + ")",
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                }}
            >
                <span className="mask bg-gradient-default opacity-8" />
                <Container className="d-flex align-items-center" fluid>
                    <Row>
                        <Col lg="7" md="10">
                            <h1 className="display-4 text-white">General Settings</h1>
                            <p className="text-white mt-0 mb-5">
                                Manage general settings for your organization.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container className="mt--7" fluid>
                <Row>
                    <Col>
                        <Card className="shadow">
                            <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                                <h3 className="mb-0">School Information</h3>
                                <Button color="info" onClick={handleEditClick}>
                                    <FaPencilAlt /> Edit
                                </Button>
                            </CardHeader>
                            <CardBody>
                                {settings ? (
                                    <div>
                                        <p><strong>School Name:</strong> {settings.schoolName}</p>
                                        <p><strong>Address:</strong> {settings.schoolAddress}</p>
                                        <p><strong>Phone Number:</strong> {settings.schoolPhoneNumber}</p>
                                        <p><strong>Email:</strong> {settings.schoolEmail}</p>
                                    </div>
                                ) : (
                                    <p>Loading settings...</p>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(false)}>
                <ModalHeader toggle={() => setEditModalOpen(false)}>Edit General Settings</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleUpdateSettings}>
                        <FormGroup>
                            <Label>School Name</Label>
                            <Input
                                type="text"
                                name="schoolName"
                                value={editedSettings.schoolName}
                                onChange={handleInputChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Address</Label>
                            <Input
                                type="text"
                                name="schoolAddress"
                                value={editedSettings.schoolAddress}
                                onChange={handleInputChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Phone Number</Label>
                            <Input
                                type="text"
                                name="schoolPhoneNumber"
                                value={editedSettings.schoolPhoneNumber}
                                onChange={handleInputChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Email</Label>
                            <Input
                                type="email"
                                name="schoolEmail"
                                value={editedSettings.schoolEmail}
                                onChange={handleInputChange}
                            />
                        </FormGroup>
                        {/* <FormGroup>
                            <Label>Logo URL</Label>
                            <Input
                                type="text"
                                name="schoolLogo"
                                value={editedSettings.schoolLogo}
                                onChange={handleInputChange}
                            />
                        </FormGroup> */}
                        <Button color="primary" type="submit">
                            Update Settings
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setEditModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Footer />
        </>
    );
};

export default GeneralSettings;
